module.exports = __webpack_public_path__ + "static/media/searchIcon.10034eba.svg";